import { render, staticRenderFns } from "./AccountOnboarding.vue?vue&type=template&id=72cac50c&scoped=true"
import script from "./AccountOnboarding.vue?vue&type=script&lang=js"
export * from "./AccountOnboarding.vue?vue&type=script&lang=js"
import style0 from "./AccountOnboarding.vue?vue&type=style&index=0&id=72cac50c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cac50c",
  null
  
)

export default component.exports